<!--
    description： 组织架构 - 组织管理 - 添加部门
-->
<template>
  <IviewModal v-bind="$attrs" @on-cancel="close" @on-ok="save" size="middle" class="iviewModal">
    <div class="form_container">
      <Form ref="form" :model="form" :rules="rules">
        <FormItem label="上级组织" prop="upDep">
          <IviewSelect v-model="form.upDep" :optionList="organSelect" :disabled="ppType != 'add'"></IviewSelect>
        </FormItem>
        <FormItem prop="title" label="组织名称" required>
          <IviewInput v-model="form.title"></IviewInput>
        </FormItem>
      </Form>
    </div>
  </IviewModal>
</template>

<script>
import { getRules } from '@/utils/check'
export default {
  name: 'addOrgan',
  inject: ['config'],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    ppType: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      rules: getRules([
        { label: '上级组织', key: 'upDep', select: true, type: 'string' },
        { label: '组织名称', key: 'title' }
      ]),
      form: {
        upDep: '',
        title: ''
      },
      organSelect: []
    }
  },
  created() {
    let { parentId, path, title, orgLevel } = this.data;
    this.$api.config.getOrganSelect().then((res) => {
      this.organSelect = res.data.map((item) => ({ ...item, label: item.groupName, value: item.groupId }))
      if (this.config.orgLevel == 1) {
        this.organSelect.push({ label: '无', value: 'null', orgLevel: 0, groupId: 'null' })
      } else if (parentId) {
        let organArr = this.organSelect.map(item => item.value);
        if (!organArr.includes(parentId)) {
          let labelArr = path.split('/'), i = labelArr.indexOf(title);
          let label = labelArr[i - 1];
          this.organSelect.push({ label, value: parentId, orgLevel: orgLevel - 1, groupId: parentId })
        }
      }
    })
    if (this.ppType == 'edit') {
      this.form.title = this.data.title
      if (this.config.orgLevel!=1) {
        this.form.upDep = this.data.parentId
      } else {
        this.form.upDep = 'null'
      }
    }
  },
  methods: {
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.organSelect.find((item) => item.groupId == this.form.upDep)
          if (this.ppType == 'add') {
            this.$api.organ
              .addDep({
                orgLevel: +data.orgLevel + 1,
                parentId: data.groupId == 'null' ? null : data.groupId,
                title: this.form.title,
                groupType: 1
              })
              .then((res) => {
                this.$Message.success('添加成功')
                this.$emit('refresh')
                this.close()
              })
          } else {
            this.$api.organ
              .putDep(
                {
                  orgLevel: +data.orgLevel+1,
                  title: this.form.title,
                },
                [this.data.value]
              )
              .then((res) => {
                this.$Message.success('修改成功')
                this.$emit('refresh')
                this.close()
              })
          }
        }
      })
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.iviewModal {
  .form_container {
    height: 100%;

    /deep/.ivu-form {
      height: 100% !important;
    }
  }
}
</style>
